<!-- components/GlobalToast.vue -->
<template>
  <div class="fixed z-50 w-full pointer-events-none" :class="positionClass">
    <transition-group name="toast-fade">
      <div v-for="toast in store.toasts" :key="toast.id"
        class="pointer-events-auto p-4 mb-2 rounded-xl shadow text-white min-w-[260px] max-w-sm"
        :class="[alignmentClass(toast.alignment), typeClass(toast.type)]">

        <div class="-mb-7">
          <svg v-if="toast.type === 'success'" width="26" height="26" viewBox="0 0 26 26" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M8 14L11 17L18 10" stroke="#10B981" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z"
              stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <svg v-else width="26" height="26" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.8043 2.0275L26.7368 21.0112C27.5031 22.3487 26.5131 24 24.9356 24H3.07055C1.49305 24 0.503055 22.3487 1.2693 21.0112L12.2018 2.0275C12.9893 0.6575 15.0168 0.6575 15.8043 2.0275Z"
              stroke="#F43F5E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14.0029 14.6667V9.66675" stroke="#F43F5E" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M14.0029 20.6667C14.8314 20.6667 15.5029 19.9952 15.5029 19.1667C15.5029 18.3383 14.8314 17.6667 14.0029 17.6667C13.1745 17.6667 12.5029 18.3383 12.5029 19.1667C12.5029 19.9952 13.1745 20.6667 14.0029 20.6667Z"
              fill="#F43F5E" />
          </svg>

        </div>
        <div v-if="toast.title" class="flex flex-row text-base font-semibold mb-1">

          <span class="ml-8">{{ toast.title }}</span>
        </div>
        <div class="ml-8 text-sm">{{ toast.message }}</div>
      </div>
    </transition-group>
  </div>
</template>

<script setup>
import { inject, computed } from "vue";

const store = inject("toastStore");

const positionClass = computed(() =>
  store.config.position === "bottom" ? "bottom-4" : "top-4"
);

function alignmentClass(a) {
  if (a === "left") return "ml-4";
  if (a === "center") return "mx-auto";
  return "mr-4 ml-auto"; // right
}

const typeClass = (t) =>
  t === "error" ? "bg-gray-600" : "bg-gray-600";
</script>

<style scoped>
/* Fade + slight slide */
.toast-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: all 0.3s ease;
}

.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
